import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';
import { getSiteUrl } from 'shared/selectors/app-settings';

import BaseShareControl from './share-base';

import translations from './translations';

import styles from './share-video.styl';


@connect(state => ({
  siteUrl: getSiteUrl(state),
}))
@VODCSSModules(styles)
export default class ShareChannel extends BaseShareControl {
  static displayName = 'ShareChannel';

  static propTypes = {
    channelData: React.PropTypes.object,
    siteUrl: React.PropTypes.string,
    ...BaseShareControl.propTypes,
  };

  title = translations.shareChannel;

  @autobind
  getShareUrl() {
    return this.props.siteUrl;
  }

  @autobind
  getContentToShare(siteUrl) {
    const { title, description, customCoverUrl, coverUrl } = this.props.channelData;

    return {
      siteUrl,
      title,
      description,
      coverUrl: customCoverUrl || coverUrl,
    };
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/share-mobile/share-channel.js